module.exports = __webpack_public_path__ + "img/수업이끝나면1.b29252f1.png";